import httpClient from "@/plugins/axios";

export const getWallpapers = async (categoryId = null) => {
    const params = categoryId ? { category: categoryId } : {};
    const response = await httpClient.get(`/v1/wallpapers/`, { params });
    return response;
}
